import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';

import ProgressiveImage from '../../components/Image/ProgressiveImage';
import Swiper from '../../components/Swiper/Swiper';

const swiperSettings = {
  slidesToScroll: 1,
  dots: true,
  infinite: false,
  autoplay: false,
  accessibility: false,
  arrows: false,
  slidesToShow: 1,
  responsive: [
    {
      // tablet
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      // mobile portrait
      breakpoint: 479,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const ListingImage = ({ image, title, handleViewPhotosClick, loadingStyle }) => {
  return (
    <Box
      onClick={(e) => handleViewPhotosClick('image', e)}
      sx={{
        height: '45vh',
        ...(image.style ? image.style : {}),
      }}
    >
      <ProgressiveImage
        alt={title}
        blurSources={image.blurSources}
        blurSrc={image.blurSrc}
        loadingStyle={loadingStyle}
        sources={image.sources}
        src={image.src}
      />
    </Box>
  );
};

const NoImagesPlaceholder = () => (
  <Grid alignItems="center" container justifyContent="center" size={12}>
    <Box
      alignItems="center"
      bgcolor="white"
      border="1px solid #FAFAFA"
      borderRadius={2}
      display="flex"
      flexDirection="column"
      height="30vh"
      justifyContent="center"
      width={1}
    >
      <HelpOutlineOutlinedIcon sx={{ fontSize: 128, color: '#FAFAFA' }} />
      <Typography variant="h5">This Listing has no images!</Typography>
    </Box>
  </Grid>
);

const SwiperMobile = ({
  isMobile,
  hasImages,
  images,
  title,
  viewPhotosButton,
  viewSurroundPhotosButton,
  onImageClick = () => {},
}) => {
  if (!isMobile) return null;

  const renderSwiper = () => (
    <Box
      bgcolor="#FAFAFA"
      sx={{
        width: '100%',
        paddingTop: '300px',
        position: 'relative',
      }}
    >
      {/* Swiper component, effectively positioned above the "Skeleton" */}
      <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
        <Swiper lazyLoad="progressive" {...swiperSettings}>
          {images.slice(0, 6).map((image, index) => (
            <ListingImage
              handleViewPhotosClick={onImageClick}
              image={image}
              key={index}
              loadingStyle={index === 0 ? 'eager' : 'lazy'}
              title={title}
            />
          ))}
        </Swiper>
      </Box>
      {viewPhotosButton}
      {viewSurroundPhotosButton}
    </Box>
  );

  return hasImages ? renderSwiper() : <NoImagesPlaceholder />;
};

export default SwiperMobile;
